$(document).on('click', '[data-open]', function (e) {

    e.preventDefault();

    const open = $($(this).data('open')),
        close = open.find('[data-close]');

    open.toggleClass($(this).data('class'));

    if (open.hasClass($(this).data('class')) && (close.length)) {
        close.trigger('click');
        return;
    }

    $(this).find('span').toggle();

});